<template v-if="Object.keys(orderByOptions).length > 1">
  <div id="order-by-mobile" class="md:hidden lg:hidden xl:hidden">
    <label class="font-bold">Order By:</label>
    <input-dropdown
      name="order"
      @change="orderBySelect"
      :initial="initialOrder"
      :items="orderByOptions"
    />
  </div>
  <div id="order-by-desktop" class="hidden gap-6 text-xl md:flex">
    <span class="font-bold">Order Agencies By:</span>
      <label
          v-if="showDistanceOrder"
          class="cursor-pointer"
          @click="orderBySelect('distance')"
      >
        <InputCheckRadio
            :currentOrder="parameters.order ?? defaultOrder"
            :order="'distance'"
        />
        Nearest (10 miles)
      </label>
      <label
          v-if="showCoversOrder"
          class="cursor-pointer"
          @click="orderBySelect('covers')"
      >
        <InputCheckRadio
            :currentOrder="parameters.order ?? defaultOrder"
            :order="'covers'"
        />
        Recommended (30 miles)
      </label>
      <label
          v-if="showStandardOrder"
          class="cursor-pointer"
          @click="orderBySelect('standard')"
      >
        <InputCheckRadio
            :currentOrder="parameters.order ?? defaultOrder"
            :order="'standard'"
        />
        National Specialists
      </label>
    </div>
</template>

<script>
import InputDropdown from 'Components/InputDropdown';
import uuid from 'Mixins/uuid';
import { mapGetters, mapMutations, mapState } from 'vuex';
import InputCheckRadio from "Components/InputCheckRadio.vue";

export default {
  name: 'SearchOrder',
  components: {InputCheckRadio, InputDropdown },
  mixins: [uuid],
  computed: {
    parameters() {
      return parameters;
    },
    ...mapGetters('search', ['searchQuery']),
    ...mapState('search', ['parameters', 'meta', 'defaultOrder']),
    initialOrder() {
      if (['standard', 'covers', 'distance'].includes(this.parameters.order)) {
        return this.parameters.order;
      }
      return this.defaultOrder;
    },
    orderByOptions() {
      const availableOrders = {};

      if (this.showCoversOrder) {
        availableOrders['covers'] = 'Agencies who cover this location';
      }
      if (this.showStandardOrder) {
        availableOrders['standard'] = 'Specialists (Location not important)';
      }
      if (this.showDistanceOrder) {
        availableOrders['distance'] = 'Agencies nearest this location';
      }

      return availableOrders;
    },
    showStandardOrder() {
      return (
        this.parameters.order === 'standard' ||
        this.meta?.sob_options?.standard === 'Y'
      );
    },
    showDistanceOrder() {
      return (
        this.parameters.order === 'distance' ||
        this.meta?.sob_options?.distance === 'Y'
      );
    },
    showCoversOrder() {
      return (
        this.parameters.order === 'covers' ||
        this.meta?.sob_options?.covers === 'Y'
      );
    },
  },
  methods: {
    ...mapMutations('search', ['setParameter']),
    orderBySelect(orderByKey, event) {
      this.setParameter({ key: 'order', value: orderByKey });

      this.link_to({
        name: 'search',
        query: this.searchQuery,
      }, true);
    },
  },
};
</script>
